import { func } from 'prop-types';
import { useEffect, useRef } from 'react';
import { useFormState } from 'react-final-form';
export default function TriggerSuccessCallback({ onSuccess }) {
    const { submitSucceeded } = useFormState({
        subscription: { submitSucceeded: true },
    });
    const calledFlagRef = useRef(false);
    useEffect(() => {
        if (submitSucceeded && calledFlagRef.current === false) {
            onSuccess();
            calledFlagRef.current = true;
        }
    }, [onSuccess, submitSucceeded]);
    return false;
}
TriggerSuccessCallback.propTypes = {
    onSuccess: func.isRequired,
};
//# sourceMappingURL=TriggerSuccessCallback.js.map